import Vue from 'vue';
import VueRouter from 'vue-router';
import saComponentVue from '@/views/sa/sa.vue';
import sicComponentVue from '@/views/sic/sic.vue';
import Home from '../views/Home.vue';

// 無分角色
import LoginRouter from './login';
import ErrorsRouter from './errors';

// 區經理
import sicChatRoomRouter from './sic/chat-room';
import sicQRCodeRouter from './sic/qr-code';
import sicItemsListRouter from './sic/items-list';
import sicProfileRouter from './sic/profile';
import sicLabelRouter from './sic/label';
import sicMsgManagerRouter from './sic/msg-manager';
import sicReservationRouter from './sic/reservation';
import sicContactsRouter from './sic/contacts';
import sicMyCustomerRouter from './sic/my-customer';
import sicGroupPushRouter from './sic/group-push';
import sicMemberSearchRouter from './sic/member-search';
import sicReportsRouter from './sic/reports';
import sicDistrictReportsRouter from './sic/district-reports';
import sicInvitationsRouter from './sic/invitation';
import sicStoreManagerRouter from './sic/stores-manager';
import sicByBaReportsRouter from './sic/by-ba-reports';
import sicByCounterReportsRouter from './sic/by-counter-reports';

// 店長
import smChatRoomRouter from './sm/chat-room';
import smItemsListRouter from './sm/items-list';
import smLabelRouter from './sm/label';
import smMsgManagerRouter from './sm/msg-manager';
import smReservationRouter from './sm/reservation';
import smStoreManagerRouter from './sm/stores-manager';
import smContactsRouter from './sm/contacts';
import smMyCustomerRouter from './sm/my-customer';

// 顧問
import saSignUpRouter from './sa/sign-up';
import saChatRoomRouter from './sa/chat-room';
import saQRCodeRouter from './sa/qr-code';
import saItemsListRouter from './sa/items-list';
import saProfileRouter from './sa/profile';
import saLabelRouter from './sa/label';
import saMsgManagerRouter from './sa/msg-manager';
import saReservationRouter from './sa/reservation';
import saContactsRouter from './sa/contacts';
import saMyCustomerRouter from './sa/my-customer';
import saGroupPushRouter from './sa/group-push';
import saMemberSearchRouter from './sa/member-search';
import saReportsRouter from './sa/reports';
import saInvitationsRouter from './sa/invitation';
import saStoreManagerRouter from './sa/stores-manager';
import saOrderOnlineRouter from './sa/order-online';
import saInformListRouter from './sa/inform-list';
import saStockRouter from './sa/stock';
import saTrialProgram from './sa/trial-program';
import saPointsCardRouter from './sa/points-card';

// 顧客
import memberSignUpRouter from './member/sign-up';
import memberChangeSaRouter from './member/change-sa';
import memberMySaRouter from './member/my-sa';
import memberBindSaRouter from './member/bind-sa';
import memberReservationRouter from './member/reservation';
import memberInvitationsRouter from './member/invitation';
import memberTrialPlanRouter from './member/trial-plan';

Vue.use(VueRouter);

const routes = [
  {
    path: '*',
    name: 'Home',
    beforeEnter: (to, from, next) => {
      const token = sessionStorage.getItem('data');

      if (token) {
        // sessionStorage 有 token 直接轉導至目的頁
        if (to.name === undefined || to.name === 'Home') {
          next('/error/404');
        } else {
          const urlParams = new URLSearchParams(window.location.search);
          window.sessionStorage.setItem('sa_id', urlParams.get('sa_id'));
          window.sessionStorage.setItem('store_id', urlParams.get('store_id'));
          if(urlParams.has('action')){
            window.sessionStorage.setItem('action', urlParams.get('action')); //action -> 用來判斷從bc綁定會員卡成功之後回到的頁面，
          }
          next();
        }
      } else {
        // 沒有 token 轉至 line login 取 token
        const responseType = 'code';
        const lineMessageChannelId = process.env.VUE_APP_LINE_MESSAGE_CHANNEL_ID;
        const lineLoginChannelId = process.env.VUE_APP_LINE_LOGIN_CHANNEL_ID;
        const redirectUri = encodeURIComponent(process.env.VUE_APP_LINE_LOGIN_REDIRECT_URL); // LINE Login 轉導至的後端 url
        // 後端轉導回前端的過渡頁 url
        const base_url = process.env.VUE_APP_BASE_URL ? process.env.VUE_APP_BASE_URL : '';
        const middleUrl = encodeURIComponent(`${window.location.protocol}//${window.location.host}${base_url}/login/index`);
        const scope = 'openid profile email';
        // 取得網址原本的 query (如果有的話)
        const queryString = window.location.href.split('?')[1];
        let state = `channel_id=${lineMessageChannelId}|login_channel_id=${lineLoginChannelId}|middle_url=${middleUrl}|final_route_name=${to.name}`;
        if (queryString !== undefined) state += `|query_string=${queryString}`;
        state = encodeURIComponent(state);
        const lineLoginUrl = `https://access.line.me/oauth2/v2.1/authorize?response_type=${responseType}&client_id=${lineLoginChannelId}&redirect_uri=${redirectUri}&scope=${scope}&bot_prompt=aggressive&state=${state}`;
        // 轉址
        window.location = lineLoginUrl;
      }
    },
    component: Home,
    children: [
      // 區經理
      {
        path: '/sic/*',
        component: sicComponentVue,
        params: true,
        meta: { requiresAuth: true },
        children: [
          sicChatRoomRouter,
          sicQRCodeRouter,
          sicItemsListRouter,
          sicProfileRouter,
          sicLabelRouter,
          sicMsgManagerRouter,
          sicReservationRouter,
          sicContactsRouter,
          sicMyCustomerRouter,
          sicGroupPushRouter,
          sicMemberSearchRouter,
          sicReportsRouter,
          sicDistrictReportsRouter,
          sicInvitationsRouter,
          sicStoreManagerRouter,
          sicByBaReportsRouter,
          sicByCounterReportsRouter,
        ]
      },
      // 店長
      smChatRoomRouter,
      smItemsListRouter,
      smLabelRouter,
      smMsgManagerRouter,
      smReservationRouter,
      smStoreManagerRouter,
      smContactsRouter,
      smMyCustomerRouter,
      // 顧問
      saSignUpRouter,
      {
        path: '/sa/*',
        component: saComponentVue,
        params: true,
        meta: { requiresAuth: true },
        children: [
          saChatRoomRouter,
          saQRCodeRouter,
          saItemsListRouter,
          saProfileRouter,
          saLabelRouter,
          saMsgManagerRouter,
          saReservationRouter,
          saContactsRouter,
          saMyCustomerRouter,
          saGroupPushRouter,
          saMemberSearchRouter,
          saReportsRouter,
          saInvitationsRouter,
          saStoreManagerRouter,
          saOrderOnlineRouter,
          saInformListRouter,
          saStockRouter,
          saTrialProgram,
          saPointsCardRouter,
        ]
      },
      // 顧客
      memberSignUpRouter,
      memberChangeSaRouter,
      memberMySaRouter,
      memberBindSaRouter,
      memberReservationRouter,
      memberInvitationsRouter,
      memberTrialPlanRouter
    ]
  },
  // For Line Login
  LoginRouter,
  // 錯誤頁面
  ErrorsRouter
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

export default router;
